<template lang="pug">
multiselect.outlet-selector(
        :options="outlets",
        v-model.number="activeOutlet",
        track-by="id",
        label="name",
        :placeholder="select_outlets"
        :loading="loading"
        :internalSearch="false"
        :showLabels="false"
        @search-change="loadOutlets"
    )
        template(slot="option" slot-scope="props")
            span.block {{ props.option.name }}
            small.text-muted
                | {{ describeOutlet(props.option) }}
    
</template>
    
    <script>
import { mapGetters, mapActions, mapMutations } from 'vuex';

export default {
    props: {
        outlet: {
            type: Number | String,
            default: 0,
        },

        allowAll: {
            type: Boolean,
            default: true,
        },

        ignoreFirstOutlet: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        let all_outlets = `All ${this.trans('general.outlets')}`;
        let select_outlets = `Select ${this.trans('general.outlets')}`;

        return {
            all_outlets,
            select_outlets,
        };
    },

    computed: {
        activeOutlet: {
            get() {
                const outlet_id = Number(this.$store.getters.activeOutlet) | 0;
                return _.find(this.outlets, { id: outlet_id });
            },

            set(value) {
                if (this.ignoreFirstOutlet) {
                    this.$store.commit('setActiveAllOutlets', value.id);
                } else {
                    this.$store.commit('setActiveOutlet', value.id);
                }

                this.$store.commit('setOutletTimezone', value.id);
            },
        },

        api() {
            return Laroute.route('franchise.vue.outlets');
        },

        ...mapGetters(['outletList']),

        loading() {
            return this.onLoading('fetch-report-outlet');
        },

        outlets: {
            get() {
                var all = [
                    {
                        id: 0,
                        name: this.all_outlets,
                    },
                ];

                if (this.allowAll) {
                    return _.concat(all, this.outletList);
                }

                return this.outletList;
            },

            set(value) {
                return this.outletList;
            },
        },
    },

    async created() {
        await this.getOutletList();

        if (this.ignoreFirstOutlet === true) {
            await this.setActiveAllOutlets(0);
            await this.setOutletTimezone(0);
        } else {
            await this.setActiveFirstOutlet();
        }

        this.setOutletCurrencyIfNecessary(this.$store.getters.activeOutlet);
    },

    methods: {
        ...mapActions(['getOutletList']),
        ...mapMutations([
            'setActiveFirstOutlet',
            'setOutletCurrencyIfNecessary',
            'setActiveAllOutlets',
            'setOutletTimezone',
        ]),

        describeOutlet(outlet) {
            let desc = [];

            if (outlet.code) {
                desc.push(outlet.code);
            }

            if (outlet.details && outlet.details.company_name) {
                desc.push(outlet.details.company_name);
            }

            return desc.join(' · ');
        },

        loadOutlets: _.debounce(async function(query) {
            await this.getOutletList({ query });
        }, 500),
    },
};
</script>
    
    <style lang="scss">
.outlet-selector {
    .multiselect__select {
        height: 36px;
    }

    .multiselect__tags {
        min-height: 38px;
    }
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/OutletSelector.vue